<template>
    <div class="pb-3">
        <p class="text-[13px] font-bold text-gray-800">
            {{ heading }}
        </p>
        <p class="text-[12px] text-gray-500 mt-1 mb-3">
            告訴我們你想要哪款，催下達人補貨。
        </p>

        <label class="block text-[13px] font-bold text-gray-700 mb-2" for="restock-remark">
            備註（選填）
        </label>
        <textarea
            id="restock-remark"
            v-model="remark"
            class="field border border-gray-200 px-3 py-2 text-[13px] text-gray-700 h-20 resize-none"
            rows="3"
            maxlength="500"
            placeholder="想講嘅話可以寫喺度"
            :disabled="submitting"
        />

        <button
            type="button"
            class="btn mt-3 h-12 w-full text-base"
            :disabled="submitting || submitted"
            @click="submit"
        >
            <span
                v-if="submitting"
                class="animate-spin w-5 h-5 border-2 border-white border-t-transparent rounded-full mr-2 inline-block align-middle"
            />
            {{ submitted ? '已通知達人' : '通知補貨' }}
        </button>

        <p
            v-if="feedback"
            class="mt-3 text-[13px] font-bold text-primary text-center leading-relaxed"
        >
            {{ feedback }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            default: null,
        },
        categoryId: {
            type: [Number, String],
            default: null,
        },
        categoryName: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            remark: '',
            feedback: '',
            submitting: false,
            submitted: false,
        };
    },

    computed: {
        heading() {
            if (this.product && this.product.name) {
                return `「${this.product.name}」已售罄`;
            }

            return this.categoryName ? `「${this.categoryName}」已售罄` : '已售罄';
        },
    },

    watch: {
        product() {
            this.feedback = '';
            this.submitted = false;
        },
    },

    methods: {
        async submit() {
            if (this.submitting || this.submitted) return;

            const payload = {};
            if (this.product && this.product.no) {
                payload.product = this.product.no;
            } else if (this.categoryId) {
                payload.category = this.categoryId;
            } else {
                return;
            }

            if (this.remark && this.remark.trim() !== '') {
                payload.remark = this.remark.trim();
            }

            try {
                this.submitting = true;
                const { data } = await this.$axios.post('/api/restock-requests', payload);
                const message = data && data.message ? data.message : '';
                this.feedback = message;
                this.submitted = true;
                if (message) {
                    this.$loader.success(message);
                }
            } catch (e) {
                this.handleErrorsMessage(e);
            } finally {
                this.submitting = false;
            }
        },
    },
};
</script>
